import { selfAxios } from "../../../../axios/selfAxios.js";
async function reqGetDetailByIds(ids) {
  const {
    data: { data }
  } = await selfAxios.post("/bsplatform/commodity/getDetailByIds", ids);
  return data;
}
export { reqGetDetailByIds };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/bsplatform/commodity/getDetailByIds/post.js